import {
  convertStringToBoolean,
  castToBoolean,
  normalizeSingleDayStartEndDates,
} from '../util';

export const OpportunityInvitationResponseInterested ='t';
export const OpportunityInvitationResponseNotInterested = 'f';

/**
 * OpportunityInvitation
 */
class OpportunityInvitation {
  constructor(data) {
    data = data || {};

    this.id = data.id;
    this.staffing_users_id = data.staffing_users_id;
    this.is_archived = data.is_archived;
    this.response = data.response;
    this.opportunities_name = data.opportunities_name;
    this.opportunities_start_date = data.opportunities_start_date;
    this.opportunities_end_date = data.opportunities_end_date;
    this.opportunities_estimated_hours = data.opportunities_estimated_hours;
    this.opportunities_goal = data.opportunities_goal;
    this.opportunity_invitation_templates_name = data.opportunity_invitation_templates_name;
    this.opportunity_invitation_templates_subject = data.opportunity_invitation_templates_subject;
    this.opportunity_invitation_templates_body = data.opportunity_invitation_templates_body;
    this.opportunity_invitation_template_attachments_document_ids = data.opportunity_invitation_template_attachments_document_ids;
    this.documents = data.documents || [];
  }

  get allowRespondYes() {
    return !this.isInterested;
  }

  get allowRespondNo() {
    return !this.isNotInterested;
  }

  get isPending() {
    return !this.isInterested && !this.isNotInterested;
  }

  get isInterested() {
    return this.response === OpportunityInvitationResponseInterested;
  }

  get isNotInterested() {
    return this.response === OpportunityInvitationResponseNotInterested;
  }

}

export default OpportunityInvitation;
